var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M32 8C18.7452 8 8 18.7452 8 32C8 45.2548 18.7452 56 32 56C45.2548 56 56 45.2548 56 32C56 18.7452 45.2548 8 32 8ZM34.5016 33.0542V46.1115H29.0991V33.0547H26.4V28.5551H29.0991V25.8536C29.0991 22.1828 30.6231 20 34.9532 20H38.5581V24.5001H36.3048C34.6192 24.5001 34.5077 25.1289 34.5077 26.3025L34.5016 28.5546H38.5836L38.1059 33.0542H34.5016Z"}));
}

FacebookInline.defaultProps = {"viewBox":"0 0 64 64","fill":"currentColor"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
